import { render, staticRenderFns } from "./StepBankIntro.vue?vue&type=template&id=055b314e&scoped=true"
import script from "./StepBankIntro.vue?vue&type=script&lang=js"
export * from "./StepBankIntro.vue?vue&type=script&lang=js"
import style0 from "./StepBankIntro.vue?vue&type=style&index=0&id=055b314e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055b314e",
  null
  
)

export default component.exports